module.exports = __webpack_public_path__ + "img/mini-prize.419f93d5.webp";